import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import BarcodeGenerator from "../../../../components/common/BarcodeGenerator";

export default function BarcodePrintFrame({itemList}: { itemList: { barcode: string, changeAmount: number }[] }) {
    const [pdfUrl, setPdfUrl] = useState<string>("");
    const pageRefs = useRef<(HTMLDivElement | null)[]>([]);
    const barcodeCache = useRef<Map<string, any>>(new Map());

    const chunkedItemList = useMemo(() => {
        const flatItemList = itemList.flatMap(item =>
            Array.from({length: item.changeAmount}, () => item.barcode)
        );

        const result: string[][] = [];
        for (let i = 0; i < flatItemList.length; i += 55) {
            result.push(flatItemList.slice(i, i + 55));
        }
        return result;
    }, [itemList]);

    const generatePdf = useCallback(async () => {
        const pdf = new jsPDF();
        const imgWidth = 210;

        for (let i = 0; i < pageRefs.current.length; i++) {
            const page = pageRefs.current[i];

            if (page) {
                const canvas = await html2canvas(page);
                const imgData = canvas.toDataURL("image/png");

                const imgHeight = (canvas.height * imgWidth) / canvas.width;

                if (i > 0) {
                    pdf.addPage();
                }

                pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
            }
        }

        const pdfBlob = pdf.output("blob");
        return URL.createObjectURL(pdfBlob);
    }, []);

    const handlePdfUrl = useCallback(async () => {
        try {
            const pdfBlobUrl = await generatePdf();
            setPdfUrl(pdfBlobUrl);
        } catch (error) {
            console.error("PDF 생성 중 오류가 발생했습니다:", error);
        }
    }, [generatePdf]);

    const renderBarcode = (barcode: string) => {
        if (barcodeCache.current.has(barcode)) {
            return barcodeCache.current.get(barcode)
        } else {
            const barcodeImage: any = <BarcodeGenerator barcode={barcode}
                                                        options={{width: 1, height: 50, fontSize: 12}}/>;
            barcodeCache.current.set(barcode, barcodeImage)
            return barcodeImage
        }
    };

    useEffect(() => {
        pageRefs.current = pageRefs.current.slice(0, chunkedItemList.length);
        itemList.length !== 0 && handlePdfUrl();
    }, [chunkedItemList, handlePdfUrl]);

    return (
        <>
            <div style={{
                position: "absolute",
                top: "-9999px",
                left: "-9999px",
                opacity: 0,
                zIndex: -1
            }}>
                <div className="barcode_content">
                    {chunkedItemList.map((chunk, index) => (
                        <div
                            className="barcode_page"
                            ref={(el) => {
                                if (el) {
                                    pageRefs.current[index] = el;
                                }
                            }}
                            key={index}
                        >
                            {chunk.map(barcode => renderBarcode(barcode))}
                        </div>
                    ))}
                </div>
            </div>
            {pdfUrl && pdfUrl !== "" ? <iframe src={pdfUrl} width="100%" height="600px"/> : <></>}
        </>
    );
}
